import Utils from "../Utils";
import router from "./../router";
import services from "./../services";

const strict = true;
const getDefaultState = () => {
  return {
    step: 1,
    passwordRecoveryRequest: null,
    vatNumber: null,
    emailAddress: null
  };
};

const state = getDefaultState();

const getters = {
  step: state => state.step,
  vatNumber: state => state.vatNumber,
  emailAddress: state => state.emailAddress
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  loadingUsernameRecoveryRequest(state) {
    state.step = 1;
    state.passwordRecoveryRequest = null;
  },
  setVatNumber(state, vatNumber) {
    state.vatNumber = vatNumber;
  },
  setEmailAddress(state, emailAddress) {
    state.emailAddress = emailAddress;
  },
  updatePasswordRecoveryStep(state, step) {
    state.step = step;
  }
};

const actions = {
  initPasswordRecoveryRequest({ commit }) {
    commit("loadingUsernameRecoveryRequest");
    const passwordRecoveryRequest = {
      username: "", //SDFSDG21S54D324A
      email: "",
      mobileNumber: "",
      confirmMobile: false,
      documentType: "",
      documentNumber: "",
      confirmDocumentNumber: false,
      region: {},
      province: {},
      city: {},
      cap: "",
      saveData: false
    };
    commit("passwordRecoveryRequestLoaded", passwordRecoveryRequest);
  },
  sendUsernameRecoveryRequest({ commit, state }) {
    let payload = {
      vatCode: state.vatNumber,
      email: state.emailAddress,
      portal: "HFPORTAL"
    };

    return services.passwordRecoveryService
      .usernameRecovery(payload)
      .then(() => {
        let success = {
          title: "homepage.username-recovery.success.title",
          message: "homepage.username-recovery.success.msg",
          closeButtonLabel: "homepage.username-recovery.success.btn",
          closeButtonClb: () => {
            router.push({
              name: "login"
            });
          }
        };
        commit("success/openSuccessDialog", success, {
          root: true
        });
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "homepage.username-recovery";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  goBackToLogin({ commit }) {
    commit("RESET");
    router.push({
      name: "login"
    });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
